import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Params } from '@angular/router';
import { environment } from '../shared/environments/environment';
import { IPaginatedResponse } from '../typing/response.interface';
import { IExternalPrice } from '../typing/external-price.interface';

@Injectable({
    providedIn: 'root'
})
export class ExternalPriceService {
    constructor(private http: HttpClient) {}

    getList(query: Params = {}): Observable<IPaginatedResponse<IExternalPrice>> {
        return this.http.get<IPaginatedResponse<IExternalPrice>>(`${environment.API_BASE_PATH}/external-prices`, { params: query });
    }

    getOne(id: number): Observable<IExternalPrice> {
        return this.http.get<IExternalPrice>(`${environment.API_BASE_PATH}/external-price/${id}`);
    }

    syncAqsiPrices(): Observable<{ created: number; updated: number; inactivated: number; total: number }> {
        return this.http.post<{ created: number; updated: number; inactivated: number; total: number }>(
            `${environment.API_BASE_PATH}/cash-provider/prices/sync`,
            {},
        );
    }
}
